import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from 'react';
import { fmtDate } from 'shared/format';
import { Tooltip, useSafeMantineTheme } from '@mantine/core';
import { FaGlobeAmericas } from 'react-icons/fa';
import { match } from 'ts-pattern';
import { DateTime } from 'luxon';
import { Publish as Pub } from '../../api/publish';
import { useQuery } from '@tanstack/react-query';
export const PublishStatus = props => {
  const $ = _c(19);
  const {
    type: t0,
    ts
  } = props;
  const type = t0 === undefined ? "published" : t0;
  const {
    colors
  } = useSafeMantineTheme();
  let t1;
  if ($[0] !== type) {
    t1 = match(type).with("published", _temp).with("liveView", _temp2).exhaustive();
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== ts) {
    t2 = ts ? ` - ${fmtDate(DateTime.fromMillis(ts), {
      showTz: true
    })}` : "";
    $[2] = ts;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `${t1}${t2}`;
  let t4;
  if ($[4] !== colors || $[5] !== type) {
    let t5;
    if ($[7] !== colors) {
      t5 = __1 => colors.green[5];
      $[7] = colors;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== colors) {
      t6 = __2 => colors.blue[5];
      $[9] = colors;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t4 = match(type).with("published", t5).with("liveView", t6).exhaustive();
    $[4] = colors;
    $[5] = type;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <FaGlobeAmericas size={20} color={t4} />;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== props || $[14] !== t5) {
    t6 = <div><PublishLink {...props}>{t5}</PublishLink></div>;
    $[13] = props;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t3 || $[17] !== t6) {
    t7 = <Tooltip label={t3}>{t6}</Tooltip>;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export const PublishLink = t0 => {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  const {
    data: url
  } = usePublishedUrl(props);
  let t1;
  if ($[3] !== children || $[4] !== url) {
    t1 = url != null ? <a target="_blank" href={url} className="break-all">{children ?? url}</a> : null;
    $[3] = children;
    $[4] = url;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export const usePublishedUrl = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = {
      queryKey: ["resultsUrl", props],
      queryFn: async () => Pub.url(props)
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
};
function _temp(_) {
  return "Published";
}
function _temp2(__0) {
  return "Live view";
}